/**
 * Returns array of unique attributes
 * @param {*} allAttributes that can be duplicates
 * @returns
 */
export const getUniqueAttributes = ({ allAttributes } = {}) => {
  const uniq = [];

  allAttributes.forEach((_a) => {
    const { short_name, name, type, description } = _a;

    const uniqEl = uniq.find(
      (_) =>
        _.short_name === short_name &&
        _.name === name &&
        _.type === type &&
        _.description === description
    );

    if (uniqEl === undefined) {
      uniq.push(_a);
    }
  });

  return uniq.sort((a, b) => a.name.localeCompare(b.name));
};



// WEBPACK FOOTER //
// ./src/custom_js/getUniqueAttributes.js